import CreateBorrowingContent from "../../content/borrowing/createBorrowing";
import { Layout } from "../../layout/page";

export function CreatedBorrowingInput() {
  return (
    <Layout>
      <CreateBorrowingContent />
    </Layout>
  );
}
